import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { addTemplateMeal } from './templates.service'
import { showToast } from '@/shared/utils/toast'
import type { TemplateMeal } from './types'

export function useAddTemplate() {
  const queryClient = useQueryClient()
  const { t } = useTranslation('templates')

  return useMutation({
    mutationFn: (templateMealId: string) => addTemplateMeal(templateMealId),
    onMutate: async (templateMealId: string) => {
      await queryClient.cancelQueries({ queryKey: ['templates', 'list'] })
      const prev = queryClient.getQueryData<TemplateMeal[]>(['templates', 'list'])
      queryClient.setQueryData<TemplateMeal[]>(['templates', 'list'], (old) =>
        old?.map((t) => (t.id === templateMealId ? { ...t, isAdded: true } : t)) ?? [],
      )
      return { prev }
    },
    onSuccess: () => {
      showToast(t('add.success'))
    },
    onError: (_err, _id, ctx) => {
      queryClient.setQueryData(['templates', 'list'], ctx?.prev)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['templates', 'list'] })
      queryClient.invalidateQueries({ queryKey: ['recipes', 'list'] })
    },
  })
}
